import * as React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

import ErrorAlert from './ErrorAlert';
import { UserContext } from './UserProvider';

export default function Login() {
   const context = React.useContext(UserContext);
   const query = new URLSearchParams(useLocation().search);
   const url = query.get("url");
   const status = query.get("status");
   const error = query.get("error");
   const errorText = query.get("error_text");
   const navigate = useNavigate();

   React.useEffect(() => {
      if (context) {
         context.setLoginStatus(Number(status));
         if (!error && url) {
            navigate(url);
         }
      }
   }, [context, status, error, url, navigate]);

   return (
      <Container sx={{ mt: 10 }} >
         <ErrorAlert errorCode={error} errorText={errorText} />
            <Typography sx={{ mt: 10 }} variant="body1">
                   <a href="mailto:webmaster@opcfoundation.org?subject=IOPApp Login Issues">Please try again later or contact the administrator</a>
            </Typography>
      </Container>
   );
}
